import { Id, useEditDrawer } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router";

export const useContactFilter = (queryKey: string[]) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const applyFilterDrawerProps = useEditDrawer();
	const queryClient = useQueryClient();

	const activeContactFilterId = useMemo(() => {
		const id = searchParams.get("contactFilterId");
		return id ? +id : null;
	}, [searchParams]);

	const onApplyContactFilter = useCallback(
		(id: Id | null) => {
			if (id) {
				setSearchParams((prev) => {
					prev.set("contactFilterId", `${id}`);
					return prev;
				});
			} else {
				setSearchParams((prev) => {
					prev.delete("contactFilterId");
					return prev;
				});
			}
			void queryClient.invalidateQueries({ queryKey: queryKey });
		},
		[queryClient, queryKey, setSearchParams],
	);

	const openContactFilterDrawer = useCallback(() => {
		applyFilterDrawerProps.handleOpen(activeContactFilterId || "new");
	}, [activeContactFilterId, applyFilterDrawerProps]);

	return {
		onApplyContactFilter,
		openContactFilterDrawer,
		activeContactFilterId,
		applyFilterDrawerProps,
	};
};
